import { index, integer, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { orderLines } from "./order-line";
import { procurements } from "./procurement";

/**
 * Line-by-line value movement. Posted to QuickBooks in a daily net, not live.
 * Writer: unit transitions that change value. `quickbooks_txn_id` is set by the daily poster.
 */
export const accountingLines = pgTable(
  "accounting_lines",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    procurementId: uuid("procurement_id").references(() => procurements.id),
    orderLineId: uuid("order_line_id").references(() => orderLines.id),
    debitAccount: text("debit_account").notNull(),
    creditAccount: text("credit_account").notNull(),
    amountCents: integer("amount_cents").notNull(),
    quickbooksTxnId: text("quickbooks_txn_id"),
    description: text("description").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => [
    index("accounting_lines_unposted_idx").on(t.createdAt),
    index("accounting_lines_procurement_idx").on(t.procurementId),
  ],
);
